import { render, staticRenderFns } from "./DiscoverItemsRuler.vue?vue&type=template&id=8e70efd8&scoped=true&"
import script from "./DiscoverItemsRuler.vue?vue&type=script&lang=js&"
export * from "./DiscoverItemsRuler.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverItemsRuler.vue?vue&type=style&index=0&id=8e70efd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e70efd8",
  null
  
)

export default component.exports